import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    ViewEncapsulation
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AuthService } from "@app/core/auth/auth.service";

@Component({
    selector: "user",
    templateUrl: "./user.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "user",
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatDividerModule,
        MatTooltipModule
    ]
})
export class UserComponent {
    private authService = inject(AuthService);

    readonly username = computed(() => this.authService.user()?.username ?? '');

    async signOut(): Promise<void> {
        await this.authService.logout();
    }
}
